import { generateCId } from "@/components/ui/TimeLine/constains/FunctionTimeline";
import { EMessageType } from "./NotificationEnum";
import { ResourceInfo } from "@/services/resource-service";

export enum ETypeNotify {
  Info = "info",
  Warning = "warning",
  Error = "error",
  Success = "success"
}


export interface INotificationInfo {
  messageType: EMessageType | null;
  message?: string | null;
  resourceInfo?: ResourceInfo;
  buttons?: IAlertButton[];
  type?: ETypeNotify;
  isRecurring?: boolean;
}
export class NotificationInfo {
  guid: string;
  messageType: EMessageType | null;
  message: string | null;
  resourceInfo?: ResourceInfo;
  buttons?: IAlertButton[];
  type: ETypeNotify;
  isRecurring?: boolean;

  constructor(dto?: INotificationInfo) {
    this.guid = generateCId();
    this.messageType = dto?.messageType || null;
    this.resourceInfo = dto?.resourceInfo;
    this.buttons = dto?.buttons;
    this.message = dto?.message || null;
    this.type = dto?.type || ETypeNotify.Warning;
    this.isRecurring = !!dto?.isRecurring;
  }
}


export interface IAlertButton {
  text: string;
  id: string;
  value: any;
  disabled?: boolean;
  onclick?: () => void;
}
